// export default () => ({
// })

export default () => ({
    units: [],
    unitsSelectable: [],
    unitsPaginatedData: null,
    unit: null,
    isLoading: false,
    isCreating: false,
    createdData: null,
    isUpdating: false,
    updatedData: null,
    isDeleting: false,
    deletedData: null
})